import { render } from "./SliderCard.vue?vue&type=template&id=d22a5f50&scoped=true"
import script from "./SliderCard.vue?vue&type=script&lang=js"
export * from "./SliderCard.vue?vue&type=script&lang=js"

import "./SliderCard.vue?vue&type=style&index=0&id=d22a5f50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22a5f50"]])

export default __exports__